<div class="appbased-tv__activation">
  <div class="appbased-tv__activation__body container p-3">
    <ng-container *ngIf="!isLoading" [ngSwitch]="currentPageState">
      <ng-container
        *ngSwitchCase="pageState.ACCOUNTSELECTION"
        [ngTemplateOutlet]="accountSelection"
      ></ng-container>
      <ng-container
        *ngSwitchCase="pageState.SUCCESS"
        [ngTemplateOutlet]="success"
      ></ng-container>
      <ng-container
        *ngSwitchCase="pageState.ERROR"
        [ngTemplateOutlet]="error"
      ></ng-container>
      <ng-container
        *ngSwitchDefault="pageState.ENTER_CODE"
        [ngTemplateOutlet]="enterCode"
      ></ng-container>
    </ng-container>

    <ng-template #enterCode>
      <ds-icon
        class="icon-overide"
        name="rds-icon-devices"
        [ariaHidden]="true"
        size="48"
        [color]="'red'"
      ></ds-icon>
      <h1 tabindex="-1" class="appbased-tv__activation__header">
        {{ "global.activation.header" | translate }}
      </h1>
      <p>{{ "global.activation.description" | translate }}</p>

      <button
        ds-button
        [attr.aria-label]="
          'global.activation.viewCompatibleDevicesAlt' | translate
        "
        [attr.title]="'global.activation.viewCompatibleDevices' | translate"
        [variant]="CTATypes.TERTIARY"
        class="mb-40"
        (click)="redirectToExternalSupport()"
      >
        {{ "global.activation.viewCompatibleDevices" | translate }}
      </button>

      <p class="text-bold">
        {{ "global.activation.enterActivationCode" | translate }}
      </p>

      <form [formGroup]="formGroup" form="ngForm">
        <div class="appbased-tv__activation__code-input-wrapper" #codeInput>
          <ds-code-input
            [a11yLabel]="'global.activation.enterActivationCodeAlt' | translate"
            [code]="code"
            [length]="6"
            [isNonNumeric]="false"
            [focusPreviousAfterClearing]="true"
            [inputType]="'text'"
            (codeChanged)="handleCodeChanged($event)"
            formControlName="codeInput"
          >
            <ds-error
              class="inline-error"
              [errorMessage]="'global.activation.invalidCode' | translate"
            ></ds-error>
          </ds-code-input>
        </div>

        <button
          ds-button
          class="mt-40 mb-16"
          [variant]="CTATypes.PRIMARY"
          (click)="handleActivateClick()"
          [attr.aria-label]="'global.activation.cta.activateAlt' | translate"
          [attr.title]="'global.activation.cta.activateAlt' | translate"
          type="submit"
        >
          {{ "global.activation.cta.activate" | translate }}
        </button>
      </form>
      <p>
        <span>{{ "global.activation.termsOfUse" | translate }}</span>
        <a
          ds-link
          [attr.href]="
            'https://www.rogers.com/support/terms/iptv-site-and-software-license-agreement'
          "
          [attr.target]="'_blank'"
          [attr.aria-label]="'global.activation.termsOfUseLinkAlt' | translate"
          [attr.title]="'global.activation.termsOfUseLink' | translate"
          [variant]="'cta'"
        >
          {{ "global.activation.termsOfUseLink" | translate }}
          <ds-icon class="right" name="open-new"></ds-icon>
        </a>
      </p>
    </ng-template>

    <ng-template #success>
      <ds-icon
        class="icon-overide"
        name="rds-icon-checkmark-outlined"
        [ariaHidden]="true"
        size="48"
        [color]="'success'"
      ></ds-icon>
      <h1 class="appbased-tv__activation__header">
        {{ "global.activation.headerSuccess" | translate }}
      </h1>
      <p>{{ "global.activation.descriptionSuccess" | translate }}</p>

      <a
        ds-link
        [attr.href]="
          'https://www.rogers.com/support/tv/faqs-about-the-rogers-xfinity-stream-app'
        "
        [attr.title]="'global.activation.cta.learnMore' | translate"
        [variant]="'cta'"
      >
        {{ "global.activation.cta.learnMore" | translate }}
      </a>
    </ng-template>

    <ng-template #error>
      <ds-icon
        class="icon-overide"
        name="rds-icon-info-outlined"
        [caption]="'global.activation.warning' | translate"
        size="48"
        [color]="'red'"
      ></ds-icon>
      <h1 class="appbased-tv__activation__header">
        {{
          "global.activation.errorCodes." + errorScenario + ".header"
            | translate
        }}
      </h1>
      <p>
        {{
          "global.activation.errorCodes." + errorScenario + ".description"
            | translate
        }}
      </p>

      <button
        *ngIf="errorScenario !== errorCodes.SUBSCRIBERS_ONLY"
        ds-button
        [attr.aria-label]="'global.activation.cta.tryAgainAlt' | translate"
        [attr.title]="'global.activation.cta.tryAgainAlt' | translate"
        [variant]="CTATypes.TERTIARY"
        class="mb-40"
        (click)="handleTryAgain()"
      >
        {{ "global.activation.cta.tryAgain" | translate }}
      </button>
      <a
        *ngIf="errorScenario === errorCodes.SUBSCRIBERS_ONLY"
        ds-link
        [attr.href]="'https://www.rogers.com/internet/ignite-bundle-packages'"
        [attr.title]="'global.activation.cta.learnMoreNoSubs' | translate"
        [variant]="'cta'"
      >
        {{ "global.activation.cta.learnMoreNoSubs" | translate }}
      </a>
    </ng-template>

    <ng-template #accountSelection>
      <rch-account-selection
        [accounts]="accountsSubscriptions"
        (onAccountSelection)="handleAccountSelection($event)"
      ></rch-account-selection>
    </ng-template>
  </div>
</div>

<ds-progress-spinner
  [isLoading]="isLoading"
  [a11yLoadedCopy]="''"
  [a11yLoadingCopy]="''"
></ds-progress-spinner>
